import { render } from "./TheHeader.vue?vue&type=template&id=cdf4a060&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=cdf4a060&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ACER\\Desktop\\Vue Course\\Main Course Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdf4a060"]])

export default __exports__